import React from 'react';
import { observer } from 'mobx-react-lite';
import { CARDS_TYPE } from '../../enums/cardTypes';
import { cardsStore } from '../../store/cardsStore';
import { winningAmountStore } from '../../store/winningAmountStore';
import { BET_TYPES } from '../../enums/cardOwner';

export const CardsSection = observer(() => {
  const { homeCard, awayCard, selectedCardType } = cardsStore;
  const { winType } = winningAmountStore;
  return (
    <div className='football-field-cards'>
      <div
        className={`football-field-card-holder ${winType === BET_TYPES.home ? 'win' : ''} ${
          CARDS_TYPE[homeCard.card] ? 'show' : ''
        }`}
      >
        {/* add class "show" "win" */}
        <div className={`football-field-card ${selectedCardType} ${CARDS_TYPE[homeCard.card]}`} />
      </div>
      <div
        className={`football-field-card-holder ${winType === BET_TYPES.away ? 'win' : ''} ${
          CARDS_TYPE[awayCard.card] ? 'show' : ''
        }`}
      >
        {/* add class "show" "win" */}
        <div className={`football-field-card ${selectedCardType} ${CARDS_TYPE[awayCard.card]}`} />
      </div>
    </div>
  );
});
